import browserCookies from 'browser-cookies';

const getValueFromCookie = (cName) => {
  const cookie = global.BROWSER ? browserCookies.get(cName) : '';
  if (cookie && cookie.includes('|')) {
    return cookie.split('|')[1];
  }
  return cookie || '';
};

export default getValueFromCookie;
